import React , { useEffect } from "react";
import {Helmet} from "react-helmet";
import { Switch, Route } from "react-router-dom";
import Aos from 'aos'
import {
    Activity,
    Auctions,
    Authors,
    ConnectWallet,
    Contact,
    CreateItem,
    Discover,
    Discover2,
    Discover3,
    Blog1,
    Blog2,
    Detailsx,
    Home,
    ItemDetails,
    Profile,
    Login,
    SignUp
} from './pages'

import HomeDemo1 from "./template/HomeDemo1"
import HomeDemo2 from "./template/HomeDemo2"
import HomeDemo3 from "./template/HomeDemo3"

import 'aos/dist/aos.css';
import './assets/css/bootstrap.min.css'
import './assets/css/global.css'
// import '../../assets/css/style.css';
// import './global.css';

import 'bootstrap/dist/js/bootstrap.bundle.min';

const App = () => {

  useEffect(() => {

    Aos.init({
      duration: 1000
      })
  },[])


  return (
    
    	<div className="App">
        <Helmet>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          <title>
            NFT Marketplace
          </title>
          <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700" rel="stylesheet" />
          <link rel="stylesheet" type="text/css" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" />
        </Helmet>

  			<Switch>
          <Route path="/" exact component={Home} />
          <Route path="/index-demo-1" exact component={HomeDemo1} />
          <Route path="/index-demo-2" exact component={HomeDemo2} />
          <Route path="/index-demo-3" exact component={HomeDemo3} />
  				<Route path="/activity" component={Activity} />
  				<Route path="/auctions" component={Auctions} />
          <Route path="/authors" component={Authors} />
  				<Route path="/connectWallet" component={ConnectWallet} />
          <Route path="/contact" component={Contact} />
          <Route path="/createitem" component={CreateItem} />
  				<Route path="/discover" component={Discover} />
          <Route path="/discover-2" component={Discover2} />
          <Route path="/discover-3" component={Discover3} />
          <Route path="/index-blog" component={Blog1} />
          <Route path="/index-blog-with-sidebar" component={Blog2} />
          <Route path="/index-single-blog" component={Detailsx} />
          <Route path="/itemDetails" component={ItemDetails} />
          <Route path="/profile" component={Profile} />
          <Route path="/login" component={Login} />
          <Route path="/signup" component={SignUp} />
  			</Switch>
	    </div>
    	
    
  );
}

export default App;